import { FeaturesItem } from '@content/features/features-type';

export const featuresContent: FeaturesItem[] = [
    {
        title: $localize`:@@feature-title-expense:Expense tracking`,
        subtitle: $localize`:@@feature-subtitle-expense:To monitor and control costs`,
        classNames: 'blue-box text-primary-color',
        screenShot: 'expense-tracking',
    },
    {
        title: $localize`:@@feature-title-inventory:Inventory management`,
        subtitle: $localize`:@@feature-subtitle-inventory:To handle physical products`,
        classNames: 'teal-box text-teal',
        screenShot: 'inventory-management',
    },
    {
        title: $localize`:@@feature-title-sales:Sales and revenue tracking`,
        subtitle: $localize`:@@feature-subtitle-sales:To understand the financial health of the business`,
        classNames: 'yellow-box text-secondary-color',
        screenShot: 'sales-and-revenue-tracking',
    },
    {
        title: $localize`:@@feature-title-employee:Employee time tracking`,
        subtitle: $localize`:@@feature-subtitle-employee:To ensure efficient use of human resources`,
        classNames: 'purple-box text-purple',
        screenShot: 'employee-time-tracking',
    },
    {
        title: $localize`:@@feature-title-customer:Customer relationship management (CRM)`,
        subtitle: $localize`:@@feature-subtitle-customer:To manage and nurture customer relationships`,
        classNames: 'cyan-box text-cyan-light',
        screenShot: 'customer-relationship-management',
    },
    {
        title: $localize`:@@feature-title-data:Data analytics and reporting`,
        subtitle: $localize`:@@feature-subtitle-data:To provide insights for decision-making`,
        classNames: 'green-box text-green-light',
        screenShot: 'data-analytics-and-reporting',
    },
    {
        title: $localize`:@@feature-title-notifications:Notifications and alerts`,
        subtitle: $localize`:@@feature-subtitle-notifications:To keep users informed of critical events`,
        classNames: 'yellow-primary-box text-secondary-color',
        screenShot: 'notifications-and-alerts',
    },
];
